import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getLeaderboard } from '../utils/api';
import Loading from './loading';
import { Link } from 'react-router-dom';

const Leaderboard = () => {
  const [leaderboard, setLeaderboard] = useState(null);
  
  useEffect(() => {
    getLeaderboard().then((res) => {
      setLeaderboard(res);
    });
  }, []);
  
  if (!leaderboard) {
    return <Loading/>
  }

  return (
    <Paper>
      <Table>
        <TableHead>
          <TableCell>Ranking</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Points</TableCell>
        </TableHead>
        <TableBody>
          {leaderboard.map((r, i) => (
            <TableRow key={i} component={Link} {...{ to: '/ascents/' + r.id } as any}>
              <TableCell>#{i+1}</TableCell>
              <TableCell>{r.name}</TableCell>
              <TableCell>{r.points}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  )
}

export default Leaderboard;